import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Container, Card, Button } from '../../styles/GlobalStyles';

const CancelContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: var(--spacing-md);
`;

const CancelCard = styled(Card)`
  width: 100%;
  max-width: 500px;
  margin: 0;
  text-align: center;
`;

const IconContainer = styled.div`
  font-size: 4rem;
  margin-bottom: var(--spacing-lg);
`;

const Title = styled.h1`
  margin-bottom: var(--spacing-md);
  color: var(--text-primary);
  font-size: 1.875rem;
  font-weight: 700;
`;

const Message = styled.p`
  margin-bottom: var(--spacing-lg);
  color: var(--text-secondary);
  line-height: 1.6;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  margin-top: var(--spacing-xl);
`;

const SecondaryButton = styled(Button)`
  background-color: var(--secondary-color);
  
  &:hover:not(:disabled) {
    background-color: var(--secondary-hover);
  }
`;

export const PaymentCancelPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <CancelContainer>
      <CancelCard>
        <IconContainer>❌</IconContainer>
        <Title>Payment Cancelled</Title>
        <Message>
          Your payment was cancelled. No charges have been made to your account.
        </Message>
        <Message>
          If you experienced any issues during checkout, please try again or contact our support team for assistance.
        </Message>

        <ButtonGroup>
          <Button onClick={() => navigate('/administration-club/register')}>
            Try Again
          </Button>
          <SecondaryButton onClick={() => navigate('/administration-club')}>
            Back to Login
          </SecondaryButton>
        </ButtonGroup>
      </CancelCard>
    </CancelContainer>
  );
};
